import type { ConversationNodeMessengerMessage } from 'lib-shared-types-api';

type RoutedThroughMessengerMessageProps = {
  node: ConversationNodeMessengerMessage;
};

export function RoutedThroughMessengerMessage({
  node,
}: RoutedThroughMessengerMessageProps): JSX.Element {
  return <>Message</>;
}
